/**
 * Shared limits. In their own module so the UI thread can import them without
 * dragging the whole engine into the main bundle.
 */

/** Matching rows kept for browsing. Counting continues past this; export is unbounded. */
export const MAX_RETAINED = 2_000_000
export const PAGE_LIMIT = 1000
